<template>
    <div
        class="
            min-h-screen
            flex flex-col
            sm:justify-center
            items-center
            pt-6
            px-4
            sm:pt-0
            bg-gray-100
        "
    >
        <div>
            <inertia-link href="/">
                <application-logo class="max-w-xs" :colour="true" />
            </inertia-link>
        </div>

        <div class="w-full sm:max-w-md">
            <slot />
        </div>
    </div>
</template>

<script>
import ApplicationLogo from "@/Components/ApplicationLogo";

export default {
    components: {
        ApplicationLogo,
    },
};
</script>
